import React from "react"

import './blogMedia.css'

const BlogMedia = ({ link, altText, imagePosition='right' }) => {
    const isMP4Format = (link) => {
        const mp4Regex = /\.(mp4)$/i;
        return mp4Regex.test(link);
    };
    
    const isYouTubeVideo = (link) => {
        const youtubeRegex = /(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|v\/|u\/\w\/|shorts\/)?([^?&]+)/;
        return youtubeRegex.test(link) || link.includes("youtu.be");
    };

    const imageExtensions = /\.(jpg|jpeg|png|svg)$/i;
    
    const isVimeoVideo = (link) => {   
        const vimeoRegex = /(?:vimeo\.com\/video|player\.vimeo\.com\/video)\/(\d+)/;   
        return vimeoRegex.test(link); 
    };

    if (isYouTubeVideo(link)) {
        const videoId = isYouTubeVideo(link) ? link.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1] : '';
        const youtubeEmbedLink = `https://www.youtube.com/embed/${videoId}`;
        return (
            <iframe 
            width="424" 
            height="238" 
            src={youtubeEmbedLink} 
            title="We Are Savor Brands" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowFullScreen></iframe>
        )
    } else if (isMP4Format(link)) {
        return (
            <div className="blog-video">
                <video controls>
                    <source src={link} type="video/mp4" />
                    <track src="captions_en.vtt" kind="captions" srcLang="en" label="English Captions"></track>
                </video>
            </div>
        )
    } else if (imageExtensions.test(link)) {
        return (
            <img src={link} className={`blog-media_image pos-${imagePosition}`} alt={altText || 'Blog Media'} />
        )
    }  else if(isVimeoVideo(link)) {
        return (
            <iframe 
            width="424" 
            height="238" 
            src={link}
            title="We Are Savor Brands" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowFullScreen></iframe>
        )
    } else {
        return (
            <>Invalid Format</>
        )
    } 
}

export default BlogMedia